import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import * as RtcClient from "@gigalot/rtc-client";
import ReconnectingWebSocket from "reconnecting-websocket";
import mitt from "mitt";
import "@mdi/font/css/materialdesignicons.css";
import { getConfigFromHsl } from "./helpers/get-config-from-hsl";

Vue.config.productionTip = false;

let firebaseConfig: any;
if (store.state.environment === "production") {
  firebaseConfig = {
    apiKey: "AIzaSyAnm2wf7gkEjHhNi59Fv2-U8-isAZhD6UA",
    authDomain: "gigalot-cloud.firebaseapp.com",
    databaseURL: "https://gigalot-cloud.firebaseio.com",
    projectId: "gigalot-cloud",
    storageBucket: "gigalot-cloud.appspot.com",
    messagingSenderId: "820134020112",
    appId: "1:820134020112:web:7b66654bf8c742a90e3695",
    measurementId: "G-29D3BKD2B5"
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyCxvvbSahUACHC8z76pXKVQex9XCGB5iY4",
    authDomain: "gigalot-testing.firebaseapp.com",
    databaseURL: "https://gigalot-testing.firebaseio.com",
    projectId: "gigalot-testing",
    storageBucket: "gigalot-testing.appspot.com",
    messagingSenderId: "17723559284",
    appId: "1:17723559284:web:6eccc09a12923e1f137021",
    measurementId: "G-TS0V73KY5J"
  };
}

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const rtcReadyCallbacks: any[] = [];
let rtcInitialized: boolean = false;

export function addRtcReadyCallback(callback: () => void) {
  if (rtcInitialized) callback();
  else rtcReadyCallbacks.push(callback);
}

function fireRtcReadyCallbacks() {
  rtcInitialized = true;
  let callback: () => void;
  while ((callback = rtcReadyCallbacks.shift())) callback();
}

type RtcEvents = {
  connectionEvent: "connected-cloud" | "connected-local" | "disconnected" | "connecting";
};
export const rtcEmitter = mitt<RtcEvents>();

type UploadEvents = {
  upload: "success" | "error";
};
export const uploadEmitter = mitt<UploadEvents>();

export function initRtc() {
  try {
    if (!(store.state as any)?.user?.location?.guid) {
      console.error("Can not init WebRTC, no locationGuid found");
      return;
    }
    store.commit("rtcSignalling", "connecting");
    RtcClient.initialize({
      locationGuid: (store.state as any).user.location.guid,
      // configuration: {
      //   iceServers: [
      //     {
      //       urls: ["turn:34.141.192.53:3478"],
      //       username: "gigalot",
      //       credential: "xN4m7kxH2wNRuCda"
      //     }
      //   ],
      //   iceCandidatePoolSize: 10
      // },
      firebaseConfig: firebaseConfig,
      server: "office",
      debug: {
        messaging: {
          sending: false,
          receiving: false,
        },
        signalling: false,
        iceCandidates: false,
        offers: false,
        answers: false,
      },
      onConnectionChange: (connected, signalling, state) => {
        console.log("onConnectionChange");
        console.log("connected", connected);
        console.log("signalling", signalling);

        if (state === "connecting") {
          store.commit("rtcSignalling", "connecting");
        } else if (state === "connected-local") {
          store.commit("rtcSignalling", "local");
          rtcEmitter.emit("connectionEvent", "connected-local");
        } else if (state === "connected-cloud") {
          store.commit("rtcSignalling", "cloud");
          rtcEmitter.emit("connectionEvent", "connected-cloud");
        } else if (state === "disconnected") {
          store.commit("rtcSignalling", "disconnected");
          rtcEmitter.emit("connectionEvent", "disconnected");
        }

        if (connected) fireRtcReadyCallbacks();
      },
      getJwt: () => store.dispatch("user/getOnlineIdToken", undefined, { root: true }),
      project: store.state.environment === "production" ? "gigalot-cloud" : "gigalot-testing",
      reconnect: {
        retryTime: 5000,
        maxRetryTime: 30 * 1000
      }
    });
  } catch (err) {
    console.error(err);
  }
}

store.dispatch("user/addFirebaseCallback", () => {
  initRtc();
});

firebase.auth().onAuthStateChanged(function (user) {
  console.log("firebase.auth().onAuthStateChanged()");
  store.dispatch("user/firebaseOnAuthStateChanged", user);
  store.dispatch("certificates/getCertificateCloud");
  //TODO: going to need to rethink this
});

store.commit("version");
store.commit("locationMismatchHardware", false);

const webSocketConnectedToProxy = new ReconnectingWebSocket(`wss://${store.getters["settings/hslAddress"]()}:9000/webSocketConnectedToProxy`);
webSocketConnectedToProxy.addEventListener("open", event => {
  console.log("webSocketConnectedToProxy open");
  if (store.state.connectedToProxy !== true) store.commit("connectedToProxy", true);
  startMessageInterval();
  (async () => {
    await getConfigFromHsl();
  })();

  store.dispatch("scale/connect");
  store.dispatch("allflex/connect");

  //store.dispatch("sync/onConnectedToProxy");
  store.dispatch("certificates/onConnectedToProxy");
});
webSocketConnectedToProxy.addEventListener("message", event => {
  console.log("webSocketConnectedToProxy message: ", event.data);
  const numInstances = parseInt(event.data);
  if (!isNaN(numInstances)) {
    store.commit("isSingleInstance", numInstances === 1);
  }
});
webSocketConnectedToProxy.addEventListener("close", event => {
  console.log("webSocketConnectedToProxy close");
  if (store.state.connectedToProxy !== false) store.commit("connectedToProxy", false);
  stopMessageInterval();
});

////////

let t: number | undefined;

function startMessageInterval() {
  if (t) return;
  t = setInterval(() => {
    try {
      webSocketConnectedToProxy.send("x");
    } catch (err) {
      console.error("failed to send heartbeat message:", err);
    }
  }, 10 * 1000);
}

function stopMessageInterval() {
  clearInterval(t);
  t = undefined;
}

////////

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
